import { PayloadAction } from '@reduxjs/toolkit';
import { Annotation } from '@api/domain/types/annotations';
import { AnnotationsState } from '@reducers/v2/annotationsV2/annotationsV2.slice';

export const addAnnotationAction = (state: AnnotationsState, action: PayloadAction<{ annotation: Annotation }>) => {
  const { annotation } = action.payload;
  const { documentId, pageNumber } = annotation;

  if (!state.byDocument[documentId]) {
    state.byDocument[documentId] = {};
  }
  if (!state.byDocument[documentId][pageNumber]) {
    state.byDocument[documentId][pageNumber] = [];
  }
  state.byDocument[documentId][pageNumber].push(annotation);
};
